module.exports = __webpack_public_path__ + "static/media/cards.a365d4c1.png";